import { translations } from '../locales/translations';

function Footer({ lang = 'ko' }) {
  const t = translations[lang];
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-white py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-title font-bold mb-4">
              {lang === 'ko' ? '한소망교회' : 'Hansomang Church'}
            </h3>
            <p className="text-white/80">
              {t.about.denominationText}
            </p>
          </div>

          <div>
            <h4 className="text-xl font-heading font-bold mb-4">
              {t.about.contact}
            </h4>
            <p className="text-white/80 mb-2">
              {t.about.phone}: 02-887-6696
            </p>
            <p className="text-white/80">
              {t.about.email}: jaden7270@gmail.com
            </p>
          </div>

          <div>
            <h4 className="text-xl font-heading font-bold mb-4">
              {t.about.location}
            </h4>
            <p className="text-white/80">
              {lang === 'ko' 
                ? '서울특별시 관악구 관악로 37길 17, 한소망교회' 
                : '1529, Nambusunhwan-ro, Gwanak-gu, Seoul, Republic of Korea'}
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/20 text-center text-white/60">
          <p>© {currentYear} {lang === 'ko' ? '한소망교회' : 'Hansomang Church'}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 